import styled from '@emotion/styled'
import { themedValue } from 'component-library/__styling/themed-value'
import { colors, metrics } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'

export const StyledConsentFallback = styled('section')(({ theme }) => ({
    padding: calcRem(theme.margins.md),
    marginBottom: calcRem(theme.margins.md),
    backgroundColor: themedValue(theme, {
        thewest: colors.thewest.greyErmine,
        fallback: colors.white,
    }),
    borderColor: themedValue(theme, {
        thewest: colors.thewest.greySeal,
        perthnow: colors.perthnow.greyPyrite,
        sevennews: colors.sevennews.alto,
    }),
    borderStyle: 'solid',
    borderWidth: 5,
    textAlign: 'center',

    p: {
        margin: 0,

        '&:not(:last-child)': {
            marginBottom: calcRem(theme.margins.sm),
        },
    },
}))
StyledConsentFallback.displayName = 'StyledConsentFallback'

export const StyledConsentHeader = styled('h2')(({ theme }) => ({
    margin: 0,
    marginBottom: calcRem(theme.margins.md),
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 700,
    fontSize: calcRem(metrics.baseFontSize),
}))
StyledConsentHeader.displayName = 'StyledConsentHeader'
